module.exports = __webpack_public_path__ + "img/c02_unitwarelephant_Normal_ua.16551888.webp";